'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const throttle = require('lodash.throttle');
const root = require('bunsen/helpers/windowCheck');
const {
    galleryPhotoImage,
    galleryPhotoFadeIn,
} = require('../helpers/GalleryConstants').galleryPhotoClasses;

class GalleryPhotoImage extends React.Component {
    constructor(props) {
        super(props);
        this._onLoad = this._onLoad.bind(this);
        this._updateImageDimensions = this._updateImageDimensions.bind(this);

        // Throttle so that the image dimensions are only updated once when the window is resized
        this._onResize = throttle(this._updateImageDimensions, 500, {
            leading: false,
            trailing: true,
        });
    }

    componentDidMount() {
        // Immediately show the image
        this._showImage();

        // Once the photo loads get the dimensions of the image (used to render itemTags)
        root.addEventListener('resize', this._onResize);
    }

    componentWillReceiveProps({ photoId }) {
        // Each time the photo is changed, hide the img component so that when then
        // new image is loaded it can be faded in
        if (photoId !== this.props.photoId) {
            this._hideImage();
        }
    }

    shouldComponentUpdate({ photoId }) {
        return photoId !== this.props.photoId;
    }

    componentWillUnmount() {
        root.removeEventListener('resize', this._onResize);
    }

    _updateImageDimensions() {
        if (this._img) {
            this.props.updateImageDimensions({
                height: 2 * this._img.offsetHeight,
                width: 2 * this._img.offsetWidth,
            });
        }
    }

    /**
     * Fades the image in by adding the 'fade-in' class
     */
    _showImage() {
        if (this._img) {
            this._img.className = classnames(galleryPhotoImage, galleryPhotoFadeIn);
        }
    }

    /**
     * Fades the image out of view by removing the 'fade-in' class
     */
    _hideImage() {
        if (this._img) {
            this._img.className = galleryPhotoImage;
        }
    }

    /**
     * Handler for img onLoad event
     *  - fades the image in
     * @private
     */
    _onLoad() {
        // set a delay to give the image time to fade in
        setTimeout(() => this._showImage(), 30);

        // Once the photo loads get the dimensions of the image (used to render itemTags)
        this._updateImageDimensions();
    }

    render() {
        const { photoSrc, photoAlt } = this.props;

        return (
            <img
                ref={img => {
                    this._img = img;
                }}
                className={galleryPhotoImage}
                src={photoSrc}
                alt={photoAlt}
                onLoad={this._onLoad}
            />
        );
    }
}

GalleryPhotoImage.propTypes = {
    photoId: PropTypes.number.isRequired,
    photoSrc: PropTypes.string.isRequired,
    photoAlt: PropTypes.string.isRequired,

    // Actions
    updateImageDimensions: PropTypes.func.isRequired,
};

module.exports = GalleryPhotoImage;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoImage.jsx